import { SU } from '../../constants';
import { defaultFactory as request } from '../../api/RequestFactory';
import suRequest from './requestFactory';
import FSA from '../FSA';

import { ISystemPatches, fetchPatches } from './Patches';

export function fetchContainer(requesterId: string, query): any {
    return request.post('me/query', query);
}
function fetchAgents(requesterId: string, query): any {
    return request.post('me/query', query);
}

export function fetchInformation(requesterId: string, query?): any {
    let customerId = query.query.customerId;
    query = {};
    return suRequest.get(`patch/${customerId}/viewFilter/all/containers`, query).then((systems) => {
        // console.log('systems: ', systems);
        return systems.reduce((r, system) => {
            r[system.cId] = system;
            return r;
        }, {});
    });
}

function assignInformation(nodes, information, agents) {
    return nodes.map((node) => {
        node.suInformation = information[node.id];
        if(node.suInformation && node.suInformation.aId) {
            node.agent = agents.find(a => a.id == node.suInformation.aId);
        }
        return node;
    });
}

export function listSystems(requesterId: string, containerQuery?, agentQuery?): any {
    return dispatch => {
        dispatch(new FSA(SU.FETCH_SYSTEMS_REQUEST).addMeta({ requesterId, containerQuery }).data);

        return fetchContainer(requesterId, containerQuery).then(containers => {
            return fetchInformation(requesterId, containerQuery).then((information) => {
                return fetchAgents(requesterId, agentQuery).then(agents => {
                    return assignInformation(containers, information, agents);
                })
            });
        }).then(nodes => {
            return dispatch(new FSA(SU.FETCH_SYSTEMS_SUCCESS).addPayload(nodes).addMeta({ requesterId, containerQuery }).data);
        }).catch(err => {
            dispatch(new FSA(SU.FETCH_SYSTEMS_FAILURE).addError(err).addMeta({ requesterId, containerQuery }).data);
            throw err;
        });
    }
}

export function listSystemsWithJobs(requesterId: string, query, jobParams) {
    return dispatch => {
        dispatch(new FSA(SU.FETCH_SYSTEMS_WITH_JOBS_REQUEST).addMeta({ requesterId, query }).data);

        return fetchContainer(requesterId, query).then(nodes => {
            const containerIds = nodes.map((node) => {
                return node.id;
            });

            return fetchInformation(requesterId, containerIds).then((information) => {
                return assignInformation(nodes, information, []);
            });
        }).then(nodes => {
            const systemIds = nodes.filter(node => {
                return !!node.suInformation;
            }).map(node => {
                return node.id;
            });

            jobParams = jobParams || {};
            jobParams.containerIds = systemIds;

          /*   return fetchJobs(requesterId, jobParams).then(jobs => {
                return dispatch(new FSA(SU.FETCH_SYSTEMS_WITH_JOBS_SUCCESS).addPayload({
                    systems: nodes,
                    jobs
                }).addMeta({ requesterId, query }).data);
            }); */
        }).catch(err => {
            dispatch(new FSA(SU.FETCH_SYSTEMS_WITH_JOBS_FAILURE).addError(err).addMeta({ requesterId, query }).data);
            throw err;
        });
    }
}


// WEBPACK FOOTER //
// ./src/actions/su/System.ts